import {
    AISummary,
    type AISummaryStatus as ComponentAISummaryStatus,
} from '@missionlabs/smartagent-app-components'
import { AISummaryStatus, AISummaryType, useGetAISummary } from 'hooks/useGetAISummary'
import useHasFeature, { AppFeatures, AppSubFeatures } from 'hooks/useHasFeature'
import { ContactState } from 'store/case/case.state'

interface Props {
    contact: ContactState
    compact?: boolean
    acw?: boolean
    title?: string
    type?: AISummaryType
}

const AISummaryWidget: React.FC<Props> = ({ compact, title, acw, type, contact }) => {
    const hasFeature = useHasFeature()

    const hasContactLensVoice = hasFeature(AppFeatures.AI_FEATURES, [
        AppSubFeatures.VOICE_SUMMARIES,
    ])

    const hasContactLensChat = hasFeature(AppFeatures.AI_FEATURES, [AppSubFeatures.CHAT_SUMMARIES])

    const hasPreContactSummaries = hasFeature(AppFeatures.AI_FEATURES, [
        AppSubFeatures.AI_ACTION_FLOWS_PRE_CONTACT_SUMMARIES_EMAIL,
        AppSubFeatures.AI_ACTION_FLOWS_PRE_CONTACT_SUMMARIES_CHAT,
    ])

    const hasPermission = hasContactLensVoice || hasContactLensChat || hasPreContactSummaries

    const { status, summaryText } = useGetAISummary({
        contact,
        type: type ?? (acw ? AISummaryType.REALTIME_CHAT : AISummaryType.VOICE_CHAT),
    })

    if (!hasPermission || status === AISummaryStatus.TOO_EARLY) {
        return null
    }

    return (
        <AISummary
            status={status as ComponentAISummaryStatus}
            summaryText={summaryText}
            compact={compact}
            title={title}
        />
    )
}

export default AISummaryWidget
